import { appBaseUrl } from "../../config/apiConfig";
import { TModelsList } from "./types";

export const getUserModels = (): Promise<TModelsList> => {
  return appBaseUrl
    .get(`/litellmmlhub/models`, {
      withCredentials: false,
    })
    .then((res) => {
      return res.data;
    });
};
